import Pages from './Pages'
import './index.less'

export default Pages